import { z } from 'zod';
import { UNIT_KEYS, type Unit } from '../units.ts';

/** A canonical unit key (`g`, `tbsp`, `clove` …; packages/shared/src/units.ts). */
export const unitSchema = z.enum(UNIT_KEYS as [Unit, ...Unit[]]);
